<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="col-sm-12 d-flex text-center justify-content-center">
                        <p>Nhấn nút "Liên kết" bên dưới để hoàn tất quá trình liên kết tới Zalo </p>
                    </div>
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                        <span>{{error}}</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="form-connect-zalo col-sm-12 d-flex flex-column gap-5 align-items-center" v-if="showButtonConnect">
                        <ButtonAddComponent :label="'Liên kết'" @click="connectZalo" :disabled></ButtonAddComponent>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>